// Hakediş ekranlarının ISO hafta hesabı ve dönem filtresi — TEK kaynak.
// Filo hakedişi ve kurye hakedişi ekranları bu hesabı ayrı ayrı kopyalıyordu; aynı hata
// iki yerde birden yaşadı (aşağıdaki mikrosaniye kırpması). Kopya yok, tek yer.

export function getISOWeek(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return { year: d.getUTCFullYear(), week: Math.ceil((((d - yearStart) / 86400000) + 1) / 7) };
}

export function getISOWeeksInYear(year) {
    return getISOWeek(new Date(Date.UTC(year, 11, 28))).week;
}

export function getWeekDateRange(year, week) {
    const jan4 = new Date(Date.UTC(year, 0, 4));
    const dow = jan4.getUTCDay() || 7;
    const mon = new Date(jan4);
    mon.setUTCDate(jan4.getUTCDate() - dow + 1 + (week - 1) * 7);
    const sun = new Date(mon);
    sun.setUTCDate(mon.getUTCDate() + 6);
    return { start: mon, end: sun };
}

export function formatWeekRange(year, week) {
    const { start, end } = getWeekDateRange(year, week);
    const opts = { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' };
    const optsShort = { day: 'numeric', month: 'short', timeZone: 'UTC' };
    if (start.getUTCFullYear() === end.getUTCFullYear()) {
        return `${start.toLocaleDateString('tr-TR', optsShort)} - ${end.toLocaleDateString('tr-TR', opts)}`;
    }
    return `${start.toLocaleDateString('tr-TR', opts)} - ${end.toLocaleDateString('tr-TR', opts)}`;
}

/** Türkiye 2016'dan beri kalıcı UTC+3 — sabit ofset güvenli. */
const TR_OFFSET_MS = 3 * 60 * 60 * 1000;

/**
 * Seçilen ISO haftasının hakediş kayıtlarını getiren `PeriodEnd` aralığı.
 *
 * Hafta seçimi hafta NUMARASINA değil, dönemin BİTİŞ TARİHİNE bakar: sözleşme bitişi /
 * erken faturalandırma kapanışları (CloseFleetPeriodNowAsync) ve aylık kapanışlar hafta
 * damgası taşımaz, numara eşitliğiyle filtrelenince hiç görünmezlerdi.
 *
 * Sunucu dönem sınırlarını TR yerel günden UTC'ye çevirerek yazar (TimeUtcProvider.
 * GetWeekRangeUtc); aynı kaydırma burada uygulanmazsa Pazartesi 00:00–03:00 TR arasında
 * kapanan dönem bir önceki haftada görünür.
 *
 * ÜST SINIRDAN 1 ms ÇIKARMA YOK: sunucu dönem sonunu tick hassasiyetiyle yazıyor
 * (2026-08-02T20:59:59.9999999Z). `between` kapsayıcıdır (>= from && <= to); üst sınır
 * ...59.999Z olarak kırpılınca gerçek kayıt 999.9 mikrosaniyeyle dışarıda kalıyor ve
 * liste BOŞ dönüyordu. Sınır, haftanın bitişini izleyen gün başı (TR) olarak verilir;
 * dönemler 7 gün arayla olduğu için bir sonraki dönemin sonuyla çakışma oluşmaz.
 */
export function buildWeekPeriodFilter(year, week) {
    const { start, end } = getWeekDateRange(year, week);
    const from = new Date(start.getTime() - TR_OFFSET_MS);
    const to = new Date(end.getTime() + 24 * 60 * 60 * 1000 - TR_OFFSET_MS);

    return {
        PeriodEnd: {
            filter: `${from.toISOString()}|${to.toISOString()}`,
            type: 'between',
            caseSensitive: false,
        },
    };
}
